import Vue from "vue";

Vue.component("crn-attachment", {
	props: ["crnAttachment"],
	computed: {
		hasAttachment() {
			return this.attachments && this.attachments.length > 0 ? true : false;
		},
		crnAttachmentLabel() {
			return htmlEntity.decode(window.labels.crnAttachments);
		},
		attachments() {
			let returnValue = [];
			if (this.crnAttachment) {
				returnValue = this.crnAttachment.split(",");
			}
			return returnValue;
		}
	},
	template: `
		<div v-if="hasAttachment">
			<b-field :label="crnAttachmentLabel">
				<div class="textarea">
					<a v-for="attachment in attachments" :key="attachment" :href="attachment" target="_blank">{{ attachment }}<br /></a>
				</div>
			</b-field>
		</div>
	`
});